import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ContentBoxContainer, ContentBoxText, ContentBoxFigure, VideoPlayer } from 'components';
import { mediaQueries, fromTabletMediaQuery } from 'utils/MediaQueriesDeprecated';
import { Routes } from 'utils/routes';

const PensionVideoContentBox = ({ ...props }) => {
    const [showVideoDialog, setShowVideoDialog] = useState(false);
    const fromTablet = mediaQueries(fromTabletMediaQuery);

    const videoId = props.videoId || 'yx8muiGvpi8';
    const text = props.text || 'Se filmen om PensionsTjek';
    const videoThumbnail = props.thumbnail || '/static/gfx/content/penly-content-hero-2.jpg';
    const toggleVideo = () => setShowVideoDialog(!showVideoDialog);

    return (
        <>
            <ContentBoxContainer { ...props }>
                <ContentBoxFigure figure={ videoThumbnail } className="brtl servicelogoinline colorWhite" onClick={ () => toggleVideo() }>
                    <div className="videoPlay">
                        <img src="/static/gfx/PlayIcon.svg" />
                        <p style={{ maxWidth:380, lineHeight:1.1 }}>{ text }</p>

                    </div>
                </ContentBoxFigure>
                <ContentBoxText className="background-primary brbr">
                    <h3>Pension behøver ikke at være uoverskueligt eller kedeligt</h3>
                    <ol className="large">
                        <li>Opret en profil og upload dine pensionsdata med NemID.</li>
                        <li>Se hvordan du kan få dine pensioner til at vokse hurtigere.</li>
                        <li>Få evt. hjælp af en uvildig rådgiver til at føre anbefalingerne ud i livet.</li>
                    </ol>
                    <Button href={ Routes.PensionCheck.Start } color="white" size={ fromTablet ? 'large' : 'medium' }>
                        Tag et PensionsTjek nu
                    </Button>
                </ContentBoxText>
            </ContentBoxContainer>
            { showVideoDialog && (
                <div className="modalOverlay" onClick={ () => toggleVideo() }>
                    <VideoPlayer videoId={ videoId } autoPlay={ true } />
                </div>
            ) }
        </>
    );
};

PensionVideoContentBox.propTypes = {
    videoId: PropTypes.string,
};

export default PensionVideoContentBox;
